// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"TermsAndConditionsManagement_buttonContainer_bCZRl","buttonItems":"TermsAndConditionsManagement_buttonItems_3HVmq"};